import { render, staticRenderFns } from "./containerBillDetail.vue?vue&type=template&id=6ced69d7&scoped=true&"
import script from "./containerBillDetail.vue?vue&type=script&lang=js&"
export * from "./containerBillDetail.vue?vue&type=script&lang=js&"
import style0 from "./containerBillDetail.vue?vue&type=style&index=0&id=6ced69d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced69d7",
  null
  
)

export default component.exports